export default "__VITE_ASSET__Bd2h3Qks__"